import { CardGeneric } from 'components/CardGeneric';
import { ModalScreenProps, ModalScreens } from 'components/Navigation/types';
import { Page } from 'components/Page';
import { Txt } from 'components/Txt';
import { useEsc } from 'hooks/useEsc';
import { useSelector } from 'hooks/useSelector';
import React from 'react';
import { useDispatch } from 'react-redux';
import { NAVIGATE_MODAL_BACK } from 'store/actions';
import { selectAssetErrors } from 'store/error/selectors';

import { SyncErrorsAsset } from './SyncErrorsAsset';
import { PageHeader } from 'components/PageHeader';

export const SyncErrorsScreen: React.FC<
  ModalScreenProps<ModalScreens.SYNCERRORS>
> = () => {
  const dispatch = useDispatch();
  const assetErrors = useSelector(selectAssetErrors);

  useEsc(() => dispatch(NAVIGATE_MODAL_BACK()));

  return (
    <Page
      scrollView
      header={
        <PageHeader
          title="Sync Issues"
          onPressCloseButton={() => dispatch(NAVIGATE_MODAL_BACK())}
        />
      }
    >
      <CardGeneric>
        <Txt>
          The following information couldn&apos;t be uploaded to RiskBase during
          sync. If the issues cannot be resolved, you can delete the
          information.
        </Txt>
      </CardGeneric>
      {assetErrors &&
        Object.entries(assetErrors).map(([id, value]) => (
          <SyncErrorsAsset key={id} assetError={value} assetId={id} />
        ))}
    </Page>
  );
};
